import React from 'react';

import Layout from '../../components/Layout';
import SEO from '../../components/SEO';

import MainHeroMassage from '../../components/HomeSections/MainHeroMassage';
import We from '../../components/HomeSections/We';
import Trademarks from '../../components/HomeSections/Trademarks';
import Areas from '../../components/HomeSections/Areas';
import Offices from '../../components/HomeSections/Offices';
import Sustentability from '../../components/HomeSections/Sustentability';
import Diversidad from '../../components/HomeSections/Diversidad';
import Testimonios from '../../components/HomeSections/Testimonios';
import Beneficios from '../../components/HomeSections/Beneficios';

export default function index() {
	return (
		<Layout page='home'>
			<SEO title='Trabaja en CCU Argentina' />
			<MainHeroMassage />
			<We />
			<Trademarks />
			<Areas />
			<Offices />
			<Sustentability />
			<Diversidad />
			<Testimonios />
			<Beneficios />
		</Layout>
	);
}
